import { useAppDispatch } from '@/Application/Hooks/Redux';
import { URL_ROUTES } from '@/constants';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';
import { setLeavingPayment } from '@/modules/perseo-billing/store/slices/billing';
import { Link } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { isDeviceAndroid, isDeviceIos } from '@/modules/perseo-billing/utils';

export const EditLink = () => {
  const { goToCheckoutMultishippingGtm } = useGtmBillingProduct();
  const dispatch = useAppDispatch();

  return (
    <Link
      weight="semibold"
      href={URL_ROUTES.SHIPPING}
      color="primary"
      onClick={(e) => {
        if (!isDeviceAndroid() && !isDeviceIos()) {
          e.preventDefault();
          goToCheckoutMultishippingGtm();
          dispatch(setLeavingPayment(URL_ROUTES.SHIPPING));
        }
      }}
    >
      Ir a editar
    </Link>
  );
};
